import * as modificationSouscriptionFormNames from "./modificationSouscriptionFormNames";

export const modificationSouscriptionInitialValues = {
  [modificationSouscriptionFormNames.CODE_PACKAGE_FORM_NAME]: "",
  [modificationSouscriptionFormNames.VALIDITE_DU_FORM_NAME]: "",
  [modificationSouscriptionFormNames.VALIDITE_AU_FORM_NAME]: "",
  [modificationSouscriptionFormNames.IDENTIFIANT_SOUSCRIPTION_FORM_NAME]: "",
  [modificationSouscriptionFormNames.MOTIF_MODIFICATION_FORM_NAME]: "",
  [modificationSouscriptionFormNames.SOLDE_SUPLEMENTAIRE_FORM_NAME]: "",
  [modificationSouscriptionFormNames.SOUSCRIPTION_SUSPENDU_FORM_NAME]: "",
  [modificationSouscriptionFormNames.TRANSACTIONS_RESTANTES_FORM_NAME]: "",
  [modificationSouscriptionFormNames.STATUS_MODIFICATION_FORM_NAME]: "",
};
